<script>

import { useToast } from "vue-toastification";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

import LoadingScreen from '@/components/General/LoadingScreen'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getSelectedPhotos, deletePhotoBulk } from '@/services/servicePhoto';

export default {
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'PhotosBulkDelete',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
	},
	props: {'photoIds': Array, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["changeAfterDeleteBulk"],
	
	data() {
		return {
			prefix:'',
		
            params:[],
            metaData:[],
           
            isLoading:true,

            menuItems:[],
            actLangs:[],
            
            helpboxData: [],
            
            basicDataCount:0,
            basicData:[],
            selectedFilterText:'',
            
            selectedGallery:'',
            optionsGalleries:[],

            selectedPhotoId:'',
			

            countPages:0,
			optionsCountRecords:[],
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			selectedPhotos:[],
			selectedPhotosAllowed:[],
			
		
			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false


		}
	},
	
	mounted:function(){

	},
	
	methods: {
		
		onLoadPage:function(){
			
			//show loader
			this.isLoading=true
					
			getSelectedPhotos({photoIds:this.photoIds}).then(response => {
				console.log(response)
				if(!response.statusText){
					console.log(response);
					
					//hide loader
					this.isLoading=false
					this.metaData = response.metaData;
					this.selectedPhotos = response.selectedData;
					this.checkSelectedPhotos();
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		

		onCloseModal:function(){
			this.modalObject.hide();
		},
				
		//kontrola vybraneho zaznamu
		//funkcia v tomto pripade nema ziaden vyznam
		checkSelectedPhotos:function(){
			
			//pole s platnymi udajmi pre zmenu datumu
			this.selectedPhotosAllowed = [];
			
			for(let i = 0; i < this.selectedPhotos.length; i++){
				this.selectedPhotosAllowed.push(this.selectedPhotos[i].id);
			}
			
			//console.log(appPhotoDeleteBulk.selectedPhotosAllowed);
		},
		
		
		onDeletePhotos:function(){
				
			if(this.selectedPhotosAllowed.length>0){
				
				this.isLoading=true
				deletePhotoBulk({photos:this.selectedPhotosAllowed}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.$emit('changeAfterDeleteBulk', '')
							this.onCloseModal();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});

			}
			
		},
		
		//systemove funkcie k zoznamu
		//(od)oznacenie vsetkych poloziek
		unSelectIds:function(){
			if(this.selectAllIds){
				for(let i = 0; i < this.basicData.length; i++){
					this.basicData[i].selectedId=true;
					this.selectedIds.push(this.basicData[i].id);
				}
				this.selectedIds = this.selectedIds.filter( this.onlyUnique );
			}else{
				for(let i = 0; i < this.basicData.length; i++){
					this.basicData[i].selectedId=false;
					var indexToRemove = this.selectedIds.indexOf(this.basicData[i].id);
					if(indexToRemove>=0){
						this.selectedIds.splice(indexToRemove, 1);
						
					}
					//this.selectedIds = [];
				}
				this.selectedIds = this.selectedIds.filter( this.onlyUnique );
			}
			//console.log(this.selectedIds);
		},
		
		//oznacenie jednej polozky
		checkSelectIds:function(index,id){
			if(this.basicData[index].selectedId==true){
				this.selectedIds.push(id);
			}else{
				var indexToRemove = this.selectedIds.indexOf(id);
				this.selectedIds.splice(indexToRemove, 1);
			}
			
			this.selectedIds = this.selectedIds.filter( this.onlyUnique );	
			//console.log(this.selectedIds);
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		//select page 
		selPage:function(x){
			
			if(x=='prev' || x=='next'){
				if(x=='prev'&&this.selectedPage!=1){this.selectedPage=this.selectedPage-1}
				if(x=='next'&&this.selectedPage!=this.countPages){this.selectedPage=this.selectedPage+1}
			}else{
				if(this.selectedPage != x){
					this.selectedPage = Number(x);
				}
			}
			//console.log(this.selectedPage);
			this.onLoadPage();
			
		},

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
	},	
	
			
	watch: {
		modalObject() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	
	
				
	<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog  modal-dialog-scrollable">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.bulkDelete') }} </h6>
					
				</div>
							
				<div class="modal-body">
											
					<div class="row">
						<div class="col-12">
							<p>Počet vybraných záznamov: {{ selectedPhotos.length }}</p>
						</div>
					</div>
													
					<div class="table-responsive">
						<table class="table table-hover table-sm">
						
							<thead>
								<tr>
									<th>id</th>
								
									<th>{{$t('msgCore.suits')}}</th>
									
									<th>{{$t('msgCore.title')}}</th>
									
									<th>{{$t('msgCore.preview')}}</th>
								
								</tr>
							</thead>
							
							<tr v-for="(basicObj) in selectedPhotos" :key="basicObj">
							
								<td>{{ basicObj.id }}</td>
																								
								<td class="align-middle">
									<i v-if="basicObj.isAllowedError" class="fas fa-times red" aria-hidden="true"></i>
									<i v-else class="fas fa-check green"  aria-hidden="true"></i>
								</td>									
								
								<td><span>{{ basicObj.title }}</span></td>
					
								<td>
									<a class="fancybox" data-fancybox="gallery" :href="basicObj.fotoData"><img :src="basicObj.fotoData" style="height: 70px;"></a>
								</td>
							</tr>

						</table>	
					</div>		
				
				</div>
				
				<div class="modal-footer">
				
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
						
						<button type="button" :disabled="!auth.photosDeleteBulk" v-on:click="onDeletePhotos()" class="btn btn-warning btn-sm">{{ $t('msgCore.btnDelete') }}</button>	
					</div>	
					
				</div>
				
			</div>

		</div>
				
	</div>
		
</template>


